import React from "react";
import { Route, Redirect } from "react-router-dom";
import NotAvailableMobileContainer from "../containers/NotAvailableMobileContainer";
import AuthService from "../service/authService";
import { ROUTES } from "../utils/Constant";
import { routeFormatter } from "../utils/Formatter";
import styles from "./Routes.module.scss";

const LoggedInRoutes = ({
  component: Component,
  adminOnly = false,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      const {
        match: {
          params: { token },
        },
      } = props;

      const currentUser = AuthService.getUserInfo();

      //If expired, alos send to login page
      const dateNow = new Date();
      if (
        !currentUser ||
        currentUser.exp * 1000 < dateNow.getTime() ||
        (adminOnly && !(currentUser.isAdmin || currentUser.isDesigner))
      ) {
        if (token) {
          return (
            <Redirect
              to={{
                pathname: routeFormatter(ROUTES.LOGIN_WITH_TOKEN, {
                  params: { token },
                }),
                state: { from: props.location },
                search: props.location.search,
              }}
            />
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: ROUTES.LOGIN,
                state: { from: props.location },
                search: props.location.search,
              }}
            />
          );
        }
      }
      return (
        <React.Fragment>
          <div className={styles.appContainer}>
            <div>
              <NotAvailableMobileContainer />
            </div>
            <div>
              <Component {...rest} {...props} />
            </div>
          </div>
        </React.Fragment>
      );
    }}
  />
);

export default LoggedInRoutes;
